import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import atualizarPessoa from '../../actions/pessoa/atualizarPessoa';
import {
    renderFieldEmail,
    renderFieldText,
    renderFieldTelefone,
    required,
    email,
    telefone
} from '../../util/inputs'
import { showSuccessMsg } from '../../util/messagesUtil';

const selector = formValueSelector('formularioCadastroEncomenda');

export class AtualizarCadastroPessoa extends Component {

    atualizar(values) {
        const parametros = {
            nome: values.nome,
            email: values.email,
            telefone: values.telefone,
            id: this.props.pessoa.id
        };
        this.props.atualizarPessoa(parametros).then(() => {
            this.props.habilitarDesabilitarBotao(false);
            showSuccessMsg('Pessoa atualizada com sucesso');
            this.props.buscarPessoa(this.props.pessoa.cpfCnpj);
        })
    }

    render() {
        const { handleSubmit, submitting, invalid, pristine } = this.props;
        return (
            <div>
                <form onSubmit={handleSubmit(this.atualizar.bind(this))}>
                    <div className="form-group">
                        <Field name="nome" type="text" validate={[required]} required={true}
                            component={renderFieldText} label="Nome Completo:"
                            css="form-control col-md-6" readOnly={false}
                        />
                    </div>
                    <div className="form-group">
                        <Field name="email" type="email" validate={[required, email]}
                            component={renderFieldEmail} label="E-mail:"
                            css="form-control col-md-6"
                        />
                    </div>
                    <div className="form-group">
                        <Field name="telefone" type="text" validate={[required, telefone]}
                            component={renderFieldTelefone}
                            css="form-control col-md-6" label="Telefone"
                        />
                    </div>
                    <button id='cancelar' type="button" className="btn btn-danger mr-2"
                        onClick={() => this.props.habilitarDesabilitarBotao(false)}>
                        Cancelar
                    </button>
                    <button type="submit" disabled={invalid || submitting || pristine}
                        className="btn btn-laranja">Salvar
                    </button>
                </form>
            </div>
        )
    }
}

export const mapStateToProps = state => (
    {
        nome: selector(state, 'nome'),
        email: selector(state, 'email'),
        telefone: selector(state, 'telefone')
    });

export default connect(mapStateToProps, { atualizarPessoa })(reduxForm({
    form: 'formularioAtualizarCadastroPessoa'
})(AtualizarCadastroPessoa));